import { gql } from '@urql/core';

const SiteNetworks = gql`
  query SiteNetworks {
    siteNetworks {
      id
      name
    }
  }
`;

export default SiteNetworks;
